import axios from "axios";
import localforage from "localforage";
import { fetchUserDetails, getToken, handleStatusGaCalls } from "../../helpers";
import { publishMonetisationcontinue } from "../Events/monetisation.events";
import { publishAppLoading } from "../Events/utils.events";
import { ANALYTICSEVENTS } from "../LoginV2/Helpers/analyticsMap";
import trackEvent  from "../../helpers/trackAnalytics";
import { getSubscriptionPlans } from "../PlansWrapper/api";
import { accessVerify } from "../Viewplans02/helper";
import pubsub from "@viewlift/pubsub";
import { fetchCurrentPlan } from "../PlansWrapper/helper";
import { pushStepToFlow } from "../helper";
import logger from "../../logger";

let baseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl

const getlocationViaCoords = async (latitude, longitude) => {
    let token = await getToken((token) => { return token })
    return axios.get(`${baseUrl}/geolocation?latitude=${latitude}&longitude=${longitude}`, {
        headers: { Authorization: token }
    }
    )
}
const getlocationInfoViaIp = async (latitude, longitude) => {
    let token = await getToken((token) => { return token })
    return axios.get(`${baseUrl}/geolocation`, {
        headers: { Authorization: token }
    }
    )
}

const updateUserIdentityData = async (payload) => {
    // Update this with graphQL Call
    let token = await getToken((token) => { return token })
    let { userId } = await fetchUserDetails()
    return axios.put(`${baseUrl}/v2/identity/${userId}`, payload, {
        headers: { Authorization: token }
    }
    )
}

const handleSetHomeLocation = async (locationData,setShowNoAccess) => {
    const hbaObj = locationData.byCoordinates ? { hba: { enabled: true, latitude: locationData?.latitude, longitude: locationData?.longitude } } : { hba: { enabled: true } }
    const AuthenticationStore = await localforage.getItem('AuthenticationStore')
    {
        locationData && updateUserIdentityData(hbaObj).then(async (res) => {
            const hba = res.data.hba
            let user = AuthenticationStore?.user
            let updatedUser = { ...user, hbaMetadata: hba }
            let currentPlan = fetchCurrentPlan()
            const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
            let locationRangeEventdata = {
                "pageUrl": checkoutInitPageDetails?.pageUrl,
                "planId": currentPlan?.planId,
                "Location": `${locationData?.latitude},${locationData?.longitude} `
            }
            if(hba?.enabled){
               let accessStatus = await accessVerify(hba)
               if (accessStatus) {
		        handleStatusGaCalls({eventName : 'location_in_range',subSection : null, type : 'location', reason : locationData, status : null, action : 'Verification', paymentStatus : null,eventCategory : 'Location Verification Success', additionalLabel : null, section : null })
                let res = await getSubscriptionPlans()
                   if (res?.length) {
                       if (locationData.byCoordinates) {
                           publishMonetisationcontinue(true)
                       } else {
                           publishMonetisationcontinue(true)
                       }
                   }else {
                       setShowNoAccess(true)
                       publishAppLoading(false)
                   }
                   let analyticsData={ename:ANALYTICSEVENTS.LOCATION_IN_RANGE, data: locationRangeEventdata};
                    pubsub.publish('user-analytics',analyticsData)
               }else {
		        handleStatusGaCalls({eventName : 'location_out_range',subSection : null, type : 'location', reason : locationData, status : null, action : 'Verification', paymentStatus : null,eventCategory : 'Location Verification Failure', additionalLabel : null, section : null })
                setShowNoAccess(true)
                publishAppLoading(false)
                let analyticsData={ename:ANALYTICSEVENTS.LOCATION_OUT_RANGE, data: locationRangeEventdata};
                pubsub.publish('user-analytics',analyticsData)
               }
              }else {
                publishMonetisationcontinue(true)
              }
            localforage.setItem('AuthenticationStore', { ...AuthenticationStore, user: updatedUser })
        }).catch((e) => {
            console.log(e)
            // setLoading(false)
        })
    }
}

const handleLocationErrorCodes = (setShowNoAccess) => {
    pushStepToFlow("location verification failed")
    localStorage.removeItem('locationCoords')
    pushStepToFlow("location verified")
    getlocationInfoViaIp().then((res) => {
        let byCoordinates = res.data.lookupMode === "coordinates" ? true : false
        const locationObj = { postalCode: res.data.postalcode, countryisocode: res.data.countryisocode, byCoordinates: byCoordinates, origip: res.data.origip }
        localStorage.setItem('locationCoords', JSON.stringify(locationObj))
        handleSetHomeLocation(locationObj, setShowNoAccess)
    }).catch(() => {
        // publish Error to show
        publishAppLoading(false)
    })
}

const requestLocation = (setShowNoAccess) => {
    let isRequestTimeout = null;
    publishAppLoading(true)
    let currentPlan = fetchCurrentPlan()
    const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
    let locationEventData = {
        "pageUrl": checkoutInitPageDetails?.pageUrl,
        "planId": currentPlan?.planId,
      }
    if (navigator.geolocation) {
        isRequestTimeout = true;
        navigator.geolocation.getCurrentPosition(
            (position) => {
                isRequestTimeout = false
                localStorage.removeItem('locationCoords')
                let coordinates = position.coords
                coordinates?.latitude && coordinates?.longitude &&
                    getlocationViaCoords(coordinates.latitude, coordinates.longitude).then((res) => {
                        locationEventData['Location'] = `${coordinates.latitude}, ${coordinates.longitude}`
                        locationEventData['message'] = "permission allowed"
                        pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.LOCATION_VERFIY, data: locationEventData});
                        let byCoordinates = res.data.lookupMode === "coordinates" ? true : false
                        const locationObj = { postalCode: res.data.postalcode, latitude: coordinates.latitude, longitude: coordinates.longitude, countryisocode: res.data.countryisocode, byCoordinates: byCoordinates, origip: res.data.origip }
                        localStorage.setItem('locationCoords', JSON.stringify(locationObj))
                        handleSetHomeLocation(locationObj,setShowNoAccess)
                        // publishMonetisationcontinue(true) //will start the payment process (CCFORM)
                        let analyticsData={ename:ANALYTICSEVENTS.USER_LOCATION,data:locationObj};
                        pushStepToFlow("location verified")
                        pubsub.publish('user-analytics',analyticsData)
                        trackEvent('USER_LOCATION', locationObj,null)
                    }).catch((e) => {
                        logger(e, 'error')
                    })
            },
            (error) => {
                isRequestTimeout = false
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        locationEventData['error'] = "PERMISSION_DENIED"
                        locationEventData['message'] = "permission denied"
                        handleLocationErrorCodes(setShowNoAccess)
                        console.log("User denied the request for Geolocation.");
                        break;
                    case error.POSITION_UNAVAILABLE:
                        locationEventData['error'] = "POSITION_UNAVAILABLE"
                        locationEventData['message'] = "permission denied"
                        handleLocationErrorCodes(setShowNoAccess)
                        console.log("Location information is unavailable.");
                        break;
                    case error.TIMEOUT:
                        locationEventData['error'] = "TIMEOUT"
                        locationEventData['message'] = "permission denied"
                        handleLocationErrorCodes(setShowNoAccess)
                        console.log("The request to get user location timed out.");
                        break;
                    default:
                        locationEventData['error'] = "permission denied"
                        locationEventData['message'] = "permission denied"
                        handleLocationErrorCodes(setShowNoAccess)
                        console.log("An unknown error occurred.");
                        break;
                }
                pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.LOCATION_VERFIY, data: locationEventData});
            }
        );
        setTimeout(() => {
            if(isRequestTimeout){
                locationEventData['error'] = "PERMISSION_DENIED"
                        locationEventData['message'] = "permission denied"
                        pushStepToFlow("location verification failed")
                        localStorage.removeItem('locationCoords')
                        pushStepToFlow("location verified")
                        getlocationInfoViaIp().then((res) => {
                            let byCoordinates = res.data.lookupMode === "coordinates" ? true : false
                            const locationObj = { postalCode: res.data.postalcode, countryisocode: res.data.countryisocode, byCoordinates: byCoordinates, origip: res.data.origip }
                            localStorage.setItem('locationCoords', JSON.stringify(locationObj))
                            handleSetHomeLocation(locationObj,setShowNoAccess)
                            pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.LOCATION_VERFIY, data: locationEventData});
                        }).catch(() => {
                            // publish Error to show
                            publishAppLoading(false)
                        })
                        logger("User denied the request for Geolocation.",'error');
            }
        },7000)
    } else {
        console.log("Geolocation is not supported by this browser.");
        publishAppLoading(false)
        publishMonetisationcontinue(false)
    }
};

export { requestLocation }